import { graphql } from '../__generated__/gql';

export const GET_ALL_JOBS = graphql(/* GraphQL */ `
  query Jobs {
    allJobs {
      jobId
      eventId
      jobDescription
      mocId
      updatedAt
      moNumber
      updatedBy
    }
  }
`);

export const GET_JOBS_BY_EVENT = graphql(/* GraphQL */ `
  query EventJobs($eventId: Int!) {
    jobsByEventId(eventId: $eventId) {
      jobId
      eventId
      jobDescription
      scheduleStatus
      fieldWalk
      mocId
      updatedAt
      moNumber
      notes
      functionalLocation
      assignedPlanner
      updatedBy
      gocStatus
      workpackRequired
      mocRequired
      materialsRequired
      longLeadMaterialsRequired
      specialistVendorsRequired
      specialistToolingRequired
      scaffoldRequired
      insulationRequired
      liftPlanRequired
      ropeAccessRequired
      isolationRequired
      riggingRequired
      heatTracingRequired
      tarMoc {
        mocNumber
      }
      tarGoc {
        jobId
        status
        sh1
      }
      tarIsolations {
        isolationNumber
        isolationId
        lineWalkPackStatus
      }
      tarInsulations {
        insulationId
        status
      }
      tarLeakTestPacks {
        leakTestPackId
        status
      }
      tarLiftPlans {
        liftPlanId
        status
      }
      tarScaffolds {
        scaffoldId
        status
      }
      tarProcedures {
        procedureId
        status
      }
      tarWorkpacks {
        workpackId
        status
      }
      leastProgressedInsulation {
        status
      }
      leastProgressedLeakTestPack {
        status
      }
      leastProgressedLiftPlan {
        status
      }
      leastProgressedProcedure {
        status
      }
      leastProgressedPurchaseOrder {
        status
      }
      leastProgressedScaffold {
        status
      }
      leastProgressedWorkpack {
        status
      }
      permits {
        permitNumber
        permitRequirement
      }
    }
  }
`);

export const GET_JOB_NAMES_BY_ASSET = graphql(/* GraphQL */ `
  query AssetJobs($assetId: Int!) {
    jobsByAssetId(assetId: $assetId) {
      jobId
      jobDescription
    }
  }
`);

export const GET_JOB_DETAILS = graphql(/* GraphQL */ `
  query JobDetails($jobId: Int!) {
    job(jobId: $jobId) {
      jobId
      eventId
      jobDescription
      notes
      scheduleStatus
      fieldWalk
      updatedAt
      moNumber
      updatedBy
      workpackRequired
      mocRequired
      materialsRequired
      longLeadMaterialsRequired
      specialistVendorsRequired
      specialistToolingRequired
      scaffoldRequired
      insulationRequired
      liftPlanRequired
      ropeAccessRequired
      isolationRequired
      riggingRequired
      heatTracingRequired
      assignedPlanner
      tarEvent {
        assetId
      }
    }
  }
`);

export const UPDATE_JOB = graphql(/* GraphQL */ `
  mutation UpdateJob($input: JobInput!) {
    updateJob(input: $input) {
      jobId
    }
  }
`);

export const GET_PERMITS_BY_TASK_IDS = graphql(/* GraphQL */ `
  query EcowPermitsByTaskIds($taskIds: [Int!]!, $moNumber: String!) {
    permitsByTaskIds(taskIds: $taskIds, moNumber: $moNumber) {
      taskId
      permitNumber
      permitOwner
      permitRequirement
      permitWalked
      comments
      timing
      updatedBy
      lastKnownTaskDescription
      ecowPermit {
        statusComment
      }
    }
  }
`);

export const GET_ECOW_PERMIT_BY_PERMIT_NUMBER = graphql(/* GraphQL */ `
  query EcowPermit($permitNumber: String!) {
    ecowPermit(permitNumber: $permitNumber) {
      permitNumber
      statusComment
      title
      locationCode
      locationDescription
    }
  }
`);

export const UPSERT_TASK_PERMIT = graphql(/* GraphQL */ `
  mutation UpsertTaskPermit($input: PermitInput!) {
    upsertTaskPermit(input: $input) {
      permitNumber
      taskId
    }
  }
`);

// TODO: This is based on the curret state and extra fields are to be removed later
export const GET_MO_DETAILS = graphql(/* Graphql */ `
  query SapMo($moNumber: String!, $isRealTime: Boolean) {
    sapMo(moNumber: $moNumber, isRealTime: $isRealTime) {
      workOrder
      workOrderDescription
      statusFioriDescription
      workType
      location
      pm
      basicFinishDate
      safetyCritical
      mainWorkCenter
      revisionCode
      assignedPlanner
      nestingCode
      viewInFiori
      labors {
        taskId
        operationDescription
        workCenter
      }
    }
  }
`);

export const GET_BATCHED_MO_DETAILS = graphql(/* Graphql */ `
  query SapMosByMoNumbers($moNumbers: [String!]!, $isRealTime: Boolean) {
    sapMosByMoNumbers(moNumbers: $moNumbers, isRealTime: $isRealTime) {
      workOrder
      workOrderDescription
      statusFioriDescription
      workType
      location
      pm
      basicFinishDate
      safetyCritical
      mainWorkCenter
      revisionCode
      assignedPlanner
      nestingCode
      viewInFiori
      labors {
        taskId
        operationDescription
        workCenter
      }
    }
  }
`);

export const GET_MO_NUMBERS_BY_REV_CODE = graphql(/* Graphql */ `
  query SapMosByRevCode($region: String!, $site: String!, $revisionCode: String!) {
    sapMoByRevCode(region: $region, site: $site, revisionCode: $revisionCode) {
      workOrder
    }
  }
`);

export const GET_EKG_FIELDS = graphql(/* Graphql */ `
  query EkgFields($location: String!) {
    ekgFields(location: $location) {
      tagNumber
      pidReference
      systemNumber
      systemDescription
    }
  }
`);

export const GET_MO_COUNT = graphql(/* Graphql */ `
  query SapMoCount($assetId: Int!, $revisionCode: String!) {
    sapMoCount(assetId: $assetId, revisionCode: $revisionCode)
  }
`);

export const CREATE_JOB = graphql(/* GraphQL */ `
  mutation CreateJob($input: JobInput!) {
    createJob(input: $input) {
      jobId
    }
  }
`);

export const GET_GOC = graphql(/* GraphQL */ `
  query GocByJobId($jobId: Int!) {
    gocByJobId(jobId: $jobId) {
      jobId
      sh1
      mc1
      status
      comments
      updatedAt
      updatedBy
    }
  }
`);

export const UPDATE_GOC = graphql(/* GraphQL */ `
  mutation UpdateGoc($input: GocInput!) {
    updateGoc(input: $input) {
      jobId
    }
  }
`);
